import React from 'react';
import { Grid, Avatar } from '@material-ui/core';
import Utils from '../providers/Utils';


export default class TaskuriList extends React.Component {
    constructor(props) {
      super(props);
       this.state = {
 
    }
    }

     componentDidMount(){
    }


    getLitereAvatar = (tx)=>{



        if(tx !== null){

            return tx.substring(0,2)
        }
    }

    getSubtaskuriLength = (idTask) =>{

       // console.log('etapaInfo :', this.props.etapaInfo);

    //    console.log('this.props.listSubtaskuri :', this.props.listSubtaskuri);

        let subtaskuriFilter = this.props.listSubtaskuri.filter(i => i.id_task_parent === idTask)

        //  console.log('subtaskuriFilter :', subtaskuriFilter);

        let subtaskuriFinalizateFilter = subtaskuriFilter.filter(i => i.statusul === 'Finalizat')

        let objR = {
            sT:subtaskuriFilter.length,
            sTF:subtaskuriFinalizateFilter.length
        }

        return objR

    }

    taskuriFilter= () =>{


        let cloneTaskuri = this.props.listTaskuri
     
        let taskuriList=[]

        let taskuriToShow=[]
       

        let u = new Utils()
        let objInfo = this.props.objProiectInfo

        // console.log('level 1 :');

//  console.log('objInfo :', objInfo);
if(objInfo){

  
        let dataStart =new Date(u.ParseDataFromSql(objInfo[0].perioada_dela))

        let dataFinish = new Date(u.ParseDataFromSql(objInfo[0].perioada_panala))
        let etapeList = this.props.listEtape

    //   console.log('etapaInfo :', this.props.etapaInfo);
      

              let full =  dataFinish.getTime() - dataStart.getTime()
      
              let defaultDate = new Date()
  
      
        

              let counter = etapeList.length

           
                taskuriList = cloneTaskuri.filter(t => t.statusul !== 'Finalizat')
          
      
            for(let i =0; i<counter; i++){

                let taskurifiltered = taskuriList.filter(t=>t.id_etapa_proiect === etapeList[i].id)

             taskurifiltered = taskurifiltered.filter(t =>( new Date(u.ParseDataFromSql(t.cand_data)) < new Date(etapeList[i].durata_pana_la) && new Date(u.ParseDataFromSql(t.pana_cand_data)) < new Date(etapeList[i].durata_pana_la) ))

            //  console.log('taskurifiltered----s-a-s-a--sa-s-a--sa- :', taskurifiltered);
             let counter2 = taskurifiltered.length

                for(let j = 0; j< counter2; j++){
                    taskuriToShow.push(taskurifiltered[j])
                }
            }
        }else{

            // console.log('level2 :');
            taskuriToShow = cloneTaskuri
        }

            //   console.log('taskuriList :', taskuriList);

             return taskuriToShow.map((e, idx)=>{
                return(
              <Grid id={e.id} style={{position:'relative'}}  onClick={()=>{this.props.onTaskClick(e, {id:e.id_etapa_proiect})}}key={idx} container className='pm-list-container-task'>
                  <div style={{backgroundColor:e.color}} className='pm-list-borderleft'></div> 
                  <i className='material-icons pm-task-done' style={{display:e.statusul !== 'Finalizat' ? 'none' : 'block'}}>done</i>  
                  <Grid  item xs={2} sm={2} md={2} lg={2} xl={2} className='pm-list-container-task-content'>
                          
                  <Avatar  style={{margin:'5px auto'}} className='pm-avatar'> { this.getLitereAvatar(e.nume + ' ') } </Avatar>

                                         
                                           
                   </Grid>

                   <Grid item xs={10} sm={10} md={10} lg={10} xl={10} className='pm-list-container-task-content'>
                                
                   <span   className='pm-list-item-task'>{e.titlu}</span> 
                   {this.getSubtaskuriLength(e.id).sT > 0 && 
                  
                          <span className='pm-subtaskuri-length-container'>
                              <i className='material-icons'>done</i>
                              {this.getSubtaskuriLength(e.id).sTF + '/'+this.getSubtaskuriLength(e.id).sT}
                      </span>
                  }
                  
                   
                 {this.afiseazaData(e.cand_data, e.pana_cand_data, this.props.dict.date)}
                  
                  
                   
                                                         
                                 </Grid>
          </Grid>
                )
            })
         

            
    }

    afiseazaData = (dataStart, dataFinish, limba) =>{

        let u = new Utils()



        if(limba === 'en'){
       
            let _dataStart = dataStart !== null ? u.dataPrescurtataEng(dataStart) : this.props.dict.noData
            let _dataFinish = dataFinish !== null ?  u.dataPrescurtataEng(dataFinish)  : this.props.dict.noData

            let span =   <span   className='pm-list-item-task-date'>{_dataStart} - {_dataFinish} </span> 
            return span
            

        }else{
            let _dataStart = dataStart !== null ? u.dataPrescurtataRomana(dataStart) : this.props.dict.noData
            let _dataFinish = dataFinish !== null ?  u.dataPrescurtataRomana(dataFinish)  : this.props.dict.noData

            let span =   <span   className='pm-list-item-task-date'>{_dataStart} - {_dataFinish} </span> 

            return span
        }
    }


     render() { 
       return (
          <div>
              {this.taskuriFilter()}
         </div>
        );
       }
}